<template>
	<div>
		<el-dialog :title="isEdit?'编辑权益':'新建权益'"
		:visible.sync="openDialog"
		width="800px"
		:before-close="handleDialogCloseAnoths"
		append-to-body="true"
		>
		<div style="height: 500px;overflow: auto;">
			<el-form
				:model="formData"
				ref="formData"
				class="backgroundForm"
				label-width="150px"
				v-loading="loading"
			>

			<el-form-item label="权益名称：" required>
					<el-input
						placeholder="请填写"
						v-model="formData.name"
						style="width: 500px"
						maxlength="20"
						show-word-limit
					></el-input>
				</el-form-item>

				<el-form-item label="权益顺序：" required>
					<el-input
						placeholder="请填写"
						v-model="formData.sort"
						style="width: 200px"
					></el-input>
					<div style="color: red; font-size: 14px">数值越小排序越前，数值相同时按照创建时间排序</div>
				</el-form-item>

				<el-form-item label="权益分类" required>
					<el-select v-model="formData.benefitCategoryId" :popper-append-to-body="false" class="returformSelect">
          	<el-option v-for="(item, index) in benefitCategoryList" :key="index" :value="item.id" :label="item.name"></el-option>
        	</el-select>
				</el-form-item>

				<el-form-item label="跳转链接：">
					<el-input
						placeholder="请填写"
						v-model="formData.jumpUrl"
						style="width: 500px"
					></el-input>
					<div style="color: red; font-size: 14px">链接需包含 .isvjcloud.com ,  .isvbjd.com或 .jd.com ;只能以 http:// ， https:// 开头</div>
				</el-form-item>

				<el-form-item label="启用状态：">
					<el-radio-group v-model="formData.status">
						<el-radio :label="0">禁用</el-radio>
						<el-radio :label="1">启用</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="权益icon（激活）：" required>
					<div></div>
					<el-upload
						ref="upload1"
						action="#"
						list-type="picture-card"
						:on-change="(file, fileList) => {handleChange(file, fileList, 'benefitEnableIconUrl')}"
						:on-remove="(file, fileList) => {handleRemove(file, fileList, 'benefitEnableIconUrl')}"
						:http-request="httpRequest"
						:file-list="fileList"
						:limit="1"
						:before-upload="beforeUpload"
						:class="fileList.length == 1?'hide_box':''"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<span style="color: red; font-size: 14px">建议尺寸：48 px*48px，图片大小不能超过300kb，类型：JPG、PNG</span>
				</el-form-item>

				<el-form-item label="权益icon（未激活）：" required>
					<div></div>
					<el-upload
						ref="upload2"
						action="#"
						list-type="picture-card"
						:on-change="(file, fileList) => {handleChange(file, fileList, 'benefitDisableIconUrl')}"
						:on-remove="(file, fileList) => {handleRemove(file, fileList, 'benefitDisableIconUrl')}"
						:http-request="httpRequest"
						:file-list="fileList2"
						:limit="1"
						:before-upload="beforeUpload"
						:class="fileList2.length == 1?'hide_box':''"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<span style="color: red; font-size: 14px">建议尺寸：48px*48px，图片大小不能超过300kb，类型：JPG、PNG</span>
				</el-form-item>

				<el-form-item label="权益详情icon：" required>
					<div></div>
					<el-upload
						ref="upload3"
						action="#"
						list-type="picture-card"
						:on-change="(file, fileList) => {handleChange(file, fileList, 'benefitDetailIconUrl')}"
						:on-remove="(file, fileList) => {handleRemove(file, fileList, 'benefitDetailIconUrl')}"
						:http-request="httpRequest"
						:file-list="fileList3"
						:limit="1"
						:before-upload="beforeUpload"
						:class="fileList3.length == 1?'hide_box':''"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
					<span style="color: red; font-size: 14px">建议尺寸：87 px*87px，图片大小不能超过300kb，类型：JPG、PNG</span>
				</el-form-item>

				<el-form-item label="权益详情：" required>
				<el-input
					type="textarea"
					placeholder="请填写"
					v-model="formData.benefitDetail"
					maxlength="500"
					style="max-width: 543px;"
					show-word-limit
					:rows="5"
				></el-input>
			</el-form-item>

			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
				<el-button @click="cancelAdd" class="cancel_Btn">取 消</el-button>
				<el-button type="primary" class="sure_Btn" @click="saveData()">确 定</el-button>
		</span>
		</el-dialog>
	</div>
</template>

<script>
import { getCategoryList,uploadpic,postMemberBenefit } from "@/api/brandCustom/brandMemberCenter";
export default {
	name: 'add-customer',
	props:{
		openDialog:{
			type:Boolean,
		},
		isEdit:{
			type:Boolean,
		},
		editData:{
			type:Object
		}
	},
	data() {
		return {
			loading:false,
			formData:{
				name:'',//权益名称
				sort:'',//权益顺序
				benefitCategoryId:'',//权益分类id
				jumpUrl:'',//跳转链接
				status:1,//启用状态
				benefitEnableIconUrl:'',//权益icon（激活）链接
				benefitDisableIconUrl:'',//权益icon（未激活）链接
				benefitDetailIconUrl:'',//权益详情icon
				benefitDetail:'',//权益详情
			},
			fileList:[],//权益icon（激活）
			fileList2:[],//权益icon（未激活）
			fileList3:[],//权益详情icon
			benefitCategoryList:[],//权益分类
		}
	},
	mounted() {
		if(this.isEdit == true) {
			this.setEdit()
		}else{
			this.formData={
				name:'',//权益名称
				sort:'',//权益顺序
				benefitCategoryId:'',//权益分类id
				jumpUrl:'',//跳转链接
				status:1,//启用状态
				benefitEnableIconUrl:'',//权益icon（激活）链接
				benefitDisableIconUrl:'',//权益icon（未激活）链接
				benefitDetailIconUrl:'',//权益详情icon
				benefitDetail:'',//权益详情
			}
		}
		this.getBenefitCategoryList()
	},
	methods: {
		//获取权益分类
		getBenefitCategoryList(){
				getCategoryList().then((res) => {
					if (res.code == 1) {
						this.benefitCategoryList = res.data
					}else{
						this.$message.error(res.message);
					}
				});
		},
		//编辑
		setEdit(){
			console.log("编辑")
			this.formData = JSON.parse(JSON.stringify(this.editData))
			this.fileList = [
				{
					url: this.formData.benefitEnableIconUrl,
					name: "权益icon（激活）链接",
				},
			];
			this.fileList2 = [
				{
					url: this.formData.benefitDisableIconUrl,
					name: "权益icon（未激活）链接",
				},
			];
			this.fileList3 = [
				{
					url:  this.formData.benefitDetailIconUrl,
					name: "权益详情icon",
				},
			];
		},
		// 保存
		saveData(){
			console.log("this.formData",this.formData)
			if(!this.formData.name){
				this.$message.warning("权益名称不可为空！");
        return;
			}
			if(!this.formData.sort){
				this.$message.warning("权益顺序不可为空！");
        return;
			}
			if(!this.formData.benefitCategoryId){
				this.$message.warning("权益分类不可为空！");
        return;
			}
			if(!this.formData.benefitEnableIconUrl){
				this.$message.warning("权益icon（激活）不可为空！");
        return;
			}
			if(!this.formData.benefitDisableIconUrl){
				this.$message.warning("权益icon（未激活）不可为空！");
        return;
			}
			if(!this.formData.benefitDetailIconUrl){
				this.$message.warning("权益详情icon不可为空！");
        return;
			}
			// 链接需包含 .isvjcloud.com ,  .isvbjd.com或 .jd.com ;只能以 http:// ， https:// 开头
			if(this.formData.jumpUrl){
				console.log(1,this.formData.jumpUrl.includes('.isvjcloud.com'))
				console.log(2,this.formData.jumpUrl.includes('.isvbjd.com'))
				console.log(3,this.formData.jumpUrl.includes('.jd.com '))
				if(!this.formData.jumpUrl.includes('.isvjcloud.com')){
					if(!this.formData.jumpUrl.includes('.isvbjd.com') ){
						if(!this.formData.jumpUrl.includes('.jd.com') ){
							this.$message.warning("跳转链接格式错误，请重新配置");
        			return;
						}
					}
				}
				console.log(4,!(/^https?:\/\//.test(this.formData.jumpUrl)))
				console.log(5,!(/^http?:\/\//.test(this.formData.jumpUrl)))
				if (!(/^https?:\/\//.test(this.formData.jumpUrl))) {
					if( !(/^http?:\/\//.test(this.formData.jumpUrl)) ){
						this.$message.warning("跳转链接格式错误，请重新配置");
						return;
					}
				}
			}
			if(!this.formData.benefitDetail){
				this.$message.warning("权益详情不可为空！");
        return;
			}

			postMemberBenefit(this.formData).then((res) => {
				console.log("res.code")
					if (res.code == 1) {
						this.$message.success("操作成功");
						this.$emit('saveData')
					}else{
						this.$message.error(res.message);
					}
				});

		},
		//上传图片
		handleChange(file, fileList,item) {
			const isLt3M = file.size < 1024 * 300;
			if (!isLt3M) {
				if(item == 'benefitEnableIconUrl'){
					this.$message.error("权益icon（激活）图片大小不符合要求，请重新上传");
					this.$refs.upload1.clearFiles();
					return
				}else if(item == 'benefitDisableIconUrl'){
					this.$message.error("权益icon（未激活）图片大小不符合要求，请重新上传");
					this.$refs.upload2.clearFiles();
					return
				}else{
					this.$message.error("权益详情icon图片大小不符合要求，请重新上传");
					this.$refs.upload3.clearFiles();
					return
				}


			} else {
				if(item == 'benefitEnableIconUrl'){
					this.fileList = fileList;
					this.$refs.upload1.$children[1].$el.style.display = "none";
				}else if(item == 'benefitDisableIconUrl'){
					this.fileList2 = fileList;
					this.$refs.upload2.$children[1].$el.style.display = "none";
				}else{
					this.fileList3 = fileList;
					this.$refs.upload3.$children[1].$el.style.display = "none";
				}

				// this.objectForm.name = file.name;
				let formdata = new FormData();
				formdata.append("file", file.raw);
					uploadpic(formdata,2).then((res) => {
						if(res.code == 1){
						// 获取图片真实url
						if(item == 'benefitEnableIconUrl'){
							this.formData.benefitEnableIconUrl = res.data.fileUrl;
						}else if(item == 'benefitDisableIconUrl'){
							this.formData.benefitDisableIconUrl = res.data.fileUrl;
						}else{
							this.formData.benefitDetailIconUrl = res.data.fileUrl;
						}
					}else{
						this.$message.error(res.message);
						if(item == 'benefitEnableIconUrl'){
							this.formData.benefitEnableIconUrl = "";
							this.$refs.upload1.$children[1].$el.style.display = "inline-block";
							this.fileList =[];
							this.$refs.upload1.clearFiles();
						}else if(item == 'benefitDisableIconUrl'){
							this.formData.benefitDisableIconUrl = "";
							this.$refs.upload2.$children[1].$el.style.display = "inline-block";
							this.fileList2 =[];
							this.$refs.upload2.clearFiles();
						}else{
							this.formData.benefitDetailIconUrl = "";
							this.$refs.upload3.$children[1].$el.style.display = "inline-block";
							this.fileList3 =[];
							this.$refs.upload3.clearFiles();
						}
					}
				});
				
			}
		},
		handleRemove(file, fileList,item) {
			if(item == 'benefitEnableIconUrl'){
				this.formData.benefitEnableIconUrl = "";
				this.$refs.upload1.$children[1].$el.style.display = "inline-block";
			}else if(item == 'benefitDisableIconUrl'){
				this.formData.benefitDisableIconUrl = "";
				this.$refs.upload2.$children[1].$el.style.display = "inline-block";
			}else{
				this.formData.benefitDetailIconUrl = "";
				this.$refs.upload3.$children[1].$el.style.display = "inline-block";
			}
		},  
		beforeUpload(file) {
			let fileType
			if (this.limitType) {
				const typeArry = [".jpg", ".png", ".JPG", ".PNG"];
				const type = file.name.substring(file.name.lastIndexOf("."));
				const isImage = typeArry.indexOf(type) > -1;
				if (!isImage) {
					fileType = false;
					this.$message({
						message: "图片格式不符合要求，请重新上传！",
						type: "warning",
					});
				}
			} else {
				fileType = true;
			}
			return fileType;
		},
		httpRequest() {},

		// 取消添加
		cancelAdd() {
			this.$emit('cancel')
		},

		handleDialogCloseAnoths() {
			this.$emit('cancel')
		}
	},
}
</script>

<style lang="scss" scoped>
/deep/.hide_box .el-upload--picture-card{
    display: none;
}
/deep/.el-textarea .el-input__count{
	right: 30px;
}
/deep/.returformSelect .el-select-dropdown {
   position: absolute !important;
   left: 0 !important;
   top: 30px !important;

 }
</style>